export default __webpack_public_path__ + "assets/404.57658c8a.svg";